import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import {
  AppRoutingModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
} from '@spartacus/storefront';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { CountrySelectorPageComponent } from './counrty-selector-page/counrty-selector-page.component';

@NgModule({
  declarations: [CountrySelectorPageComponent],
  providers: [],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    UrlModule,
    RouterModule,
    AppRoutingModule,

    ConfigModule.withConfig({
      cmsComponents: {
        CountrySelectorFlexComponent: {
          component: CountrySelectorPageComponent,
          guards: [SecureGuard],
        },
      },
    } as CmsConfig),
  ],
})
export class CountrySelectorModule { }
